<template>
  <div
    id="nowData"
    style="text-align: center"
    :class="{ dark: !$store.state.isdark }"
  >
    <div id="circle">
      <i-circle
        :stroke-color="['#ff3350', '#fbca60']"
        :trail-color="$store.state.isdark ? '#eee' : '#333'"
        :percent="getSpeedPercent()"
        dashboard
        :size="160"
      >
        <span class="demo-circle-inner" style="font-size: 40px">{{
          item.speed
        }}</span>
        <p style="margin: 4px auto 16px auto">km/h</p>
        <p>{{ item.mileage }}km</p>
        <p id="now_mileage">{{ getCurrentSpeedMileage() }}km</p>
      </i-circle>
    </div>
    <p>{{ item.gpsTime1 }}</p>

    <div
      span="24"
      class="icon-guiji"
      v-if="$store.state.control"
      v-show="!$store.state.isPrint"
    >
      <Icon @click="removeSpeed" type="md-remove" title="减速" />
      <Icon
        @click="submit"
        :type="playMol == 2 ? 'ios-play' : 'ios-pause'"
        title="播放/暂停"
      />
      <Icon @click="addSpeed" type="md-add" title="加速" />
    </div>
    倍速：{{ currentSpeedLable }}
    <p>
      {{ address }}
    </p>
    <div>
      <!-- 改动：增加 on-start 和 on-end 事件监听 -->
      <Slider
        v-model="sliderValue"
        :min="0"
        :max="getSliderMax()"
        style="width: 100%"
        @on-change="onSliderChange"
      ></Slider>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 1. 修改 speedList
      speedList: [
        { label: "0.5x", value: 20 },
        { label: "1x", value: 30 },
        { label: "1.5x", value: 45 },
        { label: "2.0x", value: 60 },
        { label: "3.0x", value: 90 }
      ],
      playMol: 2, // 2: pause, 3: playing
      model1: 1, // 存储 speedList 的当前索引，默认为 "1x"
      currentSpeedLable: "1x",
      sliderValue: 0,

      address: "暂停可查看地址",
      isDriver: false,
      item: {
        speed: 0,
        mileage: 0,
        gpsTime1: "00-00-00 00:00:00"
      },
      pointList: []
    };
  },
  methods: {
    // 2. 重写 addSpeed 方法，通过索引切换
    addSpeed() {
      this.model1 = (this.model1 + 1) % this.speedList.length;
      const newSpeed = this.speedList[this.model1];
      this.currentSpeedLable = newSpeed.label;
      this.$emit("changeSpeed", newSpeed.value);
      this.$store.state.carMsg.play = 2;
    },
    // 3. 重写 removeSpeed 方法，通过索引切换
    removeSpeed() {
      this.model1 =
        (this.model1 - 1 + this.speedList.length) % this.speedList.length;
      const newSpeed = this.speedList[this.model1];
      this.currentSpeedLable = newSpeed.label;
      this.$emit("changeSpeed", newSpeed.value);

      this.$store.state.carMsg.play = 2;
    },
    submit() {
      if (this.currentData.length <= 1) return;
      if (this.playMol == 2) {
        this.playMol = 3;
        this.$store.state.carMsg.play = 3;
        this.address = "暂停可查看地址";
      } else if (this.playMol == 3) {
        this.playMol = 2;
        this.$store.state.carMsg.play = 2;
        this.utils.jiexi(this.pointList).then(data => {
          this.address = (data[0] && data[0].address) || "地址获取失败";
        });
      }
      this.$emit("parentFn", this.playMol);
    },
    onSliderChange(newValue) {
      this.$emit("changeSlider", newValue);
    },

    changeCurentPoint(v, now) {
      if (now <= 0) {
        this.sliderValue = 0;
        return;
      }

      const percentage = (v / now) * 100;
      this.sliderValue = percentage;
    },
    showMsg(v) {
      this.item = v;
      this.pointList = [{ x: v.locateLng, y: v.locateLat }];
    },
    // 4. 修改 getCurrentSpeedMileage 方法，替换 ?.
    getCurrentSpeedMileage() {
      if (!this.currentData || this.currentData.length === 0) return "0.00";

      // 使用传统的 && 判断来替代 ?.
      const currentMileage = this.item.mileage || 0;
      const startMileage = this.currentData[0].mileage || 0;

      const result = Math.max(0, currentMileage - startMileage).toFixed(2);
      return result;
    },
    getSpeedPercent() {
      const speed = this.item.speed || 0;
      return Math.min(100, Math.max(0, (speed / 140) * 100));
    },
    getSliderMax() {
      return this.currentData.length > 0 ? 100 : 0;
    },
    dark() {
      this.$store.state.isdark = !this.$store.state.isdark;
      this.$emit("dark");
    },
    setDriver() {
      this.isdriver = !this.isdriver;
      this.$emit("jiashi", this.isdriver);
    },
    upDown() {
      this.isDown = !this.isDown;
    },
    reset() {
      this.playMol = 2;
      this.$store.state.carMsg.play = 2;
      this.sliderValue = 0;
      // 重置倍速到默认的 "1x"
      this.model1 = 1;
      this.currentSpeedLable = this.speedList[1].label;
    }
  },
  watch: {
    currentData: {
      handler(newVal) {
        this.reset();
        if (newVal && newVal.length > 0) {
          this.showMsg(newVal[0]);
          const pointList = [
            { x: newVal[0].locateLng, y: newVal[0].locateLat }
          ];
          this.utils.jiexi(pointList).then(data => {
            this.address = (data[0] && data[0].address) || "地址获取失败";
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.currentData && this.currentData.length > 0) {
      this.showMsg(this.currentData[0]);
    }
  }
};
</script>
<style>
#nowData {
  background: #fff;
  padding: 20px 15px 4px 15px;
  z-index: 200;
  color: #333;
  width: 240px;
  overflow: hidden;
}
#now_mileage {
  font-size: 20px;
  background: #fa8424;
  color: #fff;
  width: 100px;
  margin: auto;
  margin-bottom: -30px;
  margin-top: 4px;
  line-height: 24px;
  position: relative;
}
#now_mileage::before {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: 0;
  left: -16px;
  border-right: 16px solid #fa8424;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}
#now_mileage::after {
  width: 0;
  height: 0;
  content: "";
  position: absolute;
  top: 0;
  right: -16px;
  border-left: 16px solid #fa8424;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}
.icon-guiji {
  margin-top: 20px;
  margin-bottom: 20px;
}
.icon-guiji i {
  font-size: 22px;
  padding: 0.3em;
  margin: 0 2px;
  border-radius: 1em;
  color: #fff;
  background: #fa8424;
  opacity: 1;
}
.icon-guiji i:hover {
  opacity: 0.8;
  cursor: pointer;
}
#nowData .ivu-slider-bar {
  background: #fa8424;
}
</style>



// WEBPACK FOOTER //
// src/components/locus/nowData.vue